module.exports = __webpack_public_path__ + "src/assets/img/addphoto.cc6ff956.svg";